export default {"src":"/_next/static/media/2.ee948651.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};